import React from 'react'
import Heading from '../../shared/utils/Heading'
import { Box, Typography } from '@mui/material'
import CustomDivider from '../../shared/utils/CustomDivider'
import { Page_Padding } from '../../shared/constants'
import { useAboutUse } from '../../assets/api/useGetApi'
import { TextSkeleton } from '../../shared/utils/SkeletonCom'

const AboutUs = () => {
    const { data, isLoading, } = useAboutUse();
    return (
        <Box className="body contact_us" px={Page_Padding}>
            <Box width={{ xs: "100%", md: "80%" }}>
                {isLoading && <TextSkeleton width={"100%"} line={3} />}
                {!isLoading &&
                    <Heading
                        Heading={data?.data?.heading}
                        SubHeading={data?.data?.short_title}
                        mb={2}
                    />
                }

            </Box>
            {isLoading && <TextSkeleton width={"100%"} line={3}  />}
            {!isLoading && <Typography variant="body2" color='grey.400' mb={3}>
                {data?.data?.description}
            </Typography>}

            {/* <AddSection /> */}
            {/* <CustomDivider />
            <Heading
                Heading={"Building Strong Foundations for a Brighter Future"}
                SubHeading={"Why Choose Us?"}
                mb={2}
            />
            <Typography variant="body2" color='grey.400' mb={3}>
                At MySkool, we focus on holistic development, nurturing both academic excellence and essential life skills. Our vibrant environment encourages exploration, critical thinking, and collaboration, helping children grow into confident and capable individuals. With expert educators, interactive lessons, and a supportive community, MySkool is where young minds thrive and dreams take flight.
            </Typography>
            <AddSection />
            <CustomDivider />
            <Heading
                Heading={"Where Passion Meets Excellence"}
                SubHeading={"What Sets Us Apart?"}
                mb={2}
            />
            <Typography variant="body2" color='grey.400'>
                At MySkool, we focus on holistic development, nurturing both academic excellence and essential life skills. Our vibrant environment encourages exploration, critical thinking, and collaboration, helping children grow into confident and capable individuals. With expert educators, interactive lessons, and a supportive community, MySkool is where young minds thrive and dreams take flight.
            </Typography>

            <CustomDivider /> */}
            <CustomDivider />
            <Typography
                variant="h6"
                sx={{
                    textAlign: "center",
                    width: { xs: "100%", md: "80%" },
                    margin: "0 auto", // Centers the text block
                    fontSize: "18px"
                }}
            >
                MySkill isn’t just a school—it’s a place where young minds thrive,
                creativity flourishes, and every child’s journey to success begins.
            </Typography>


            <CustomDivider />
        </Box>
    )
}

export default AboutUs